import { apiRequest, handleCall } from 'syft-acp-core/api/call'

export const fetchCountries = () =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: '/countries' })
    handleCall(req, resolve, reject)
  })
